export const state = {
    produto: {
        tipo: "PRODUTO",
        descricao: "",
        marca: "",
        codigo_barra: "",
        unidade: "UN",
        referencia: "",
        preco_custo: "0,00",
        margem_lucro: "0,00",
        preco_venda: "0,00",
        cfop: "5.102",
        cfop_fora_estado: "6.102",
        cest: "",
        ncm: "",
        fornecedor_id: "",
        secao_id: "",
        grupo_id: "",
        cst_csosn: "102",
        cst_pis: "08",
        cst_confins: "08",
        cst_ipi: "",
        habilitado: true,
        descricao_servico: "",
        estoque_minimo: "",
        tanque: false,
        capacidade_litro: '0,00',
        altura: '0,00',
        largura: '0,00',
        profundidade: '0,00',
        desconto_maximo: '0,00',
        comissao: '0,00',
    },
    produtos: [],
    modalCadastroProduto: false,
    modalExcluirProduto: false,
    tiposProduto: [
        "PRODUTO",
        "SERVIÇO"
    ],
    foto: null,
    modalTransferenciaEstoqueProduto: false,
    modalClonarProduto: false

}

export default {}